import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Col, CountryDropdown, DatePicker, Input, Radio, Row, Select, Slider, TextArea, TimePicker, Toast, Toggle } from "@kaleyra/emmy";
import { useTranslation } from 'react-i18next';
import Styles from './index.module.scss';
import { ConfigurationData } from '../../../../../../interface/receiveMessage';
import TemplateAttachIcon from '../../../../../../assets/templateAttachIcon.svg';
import moment, { Moment } from 'moment';
import { isEmpty } from 'lodash';
import cn from "classnames";
import SelectTemplate from '../../../containers/receive-message/selectTemplate';
import SelectUrl from '../../../containers/receive-message/selectUrl';
import { checkTextEncodingType, validateEmail, validateOnlyNumbers, validatePhoneNumber,removeEmojisTextfield } from '../../../../../../utils';
import { networkCall, apiBaseUrl } from '../../../../../../utils/networkCall';
import { TemplateTypeSidebar } from '../newConfiguration';

enum ReplyTypeEnum {
    instant = 0,
    scheduled
}

export type IOptions = {
    label: string,
    value: string
}

enum TriggerTypeEnum {
    url = 0,
    callback
}

export enum SidebarType {
    template = 0,
    url
}

export type MapStateType = {
    id: any,
    configurationList: ConfigurationData[];
    templateData: any;
    callbackProfileList: any[];
    selectedTemplateId: string;
    urlList: any;
    selectedUrlId: string;
    createdUrl: string;
    profile: any;
    countryList: any[];
};

export type DispatchPropsType = {
    onLoad: () => void;
    onClose: () => void;
    loadCallbackProfiles: () => void;
    onLoadTemplates: () => void;
    onLoadUrls: () => void;
    onSelectUrl: (urlData: any, sidebarType: string, getSidebarType: (type: string) => void) => void;
    onSelectTemplate: (templatesData: any, sidebarType: string, getSidebarType: (type: string) => void) => void;
    onSave: (formData: any, successCallback: (res: any, flag: boolean) => void) => void;
    fetchCountryList: () => void;
    updateSelectedTemplateInStore: (templateId: string) => void;
};

const ConfigurationEditForm: React.FC<MapStateType & DispatchPropsType> = ({ id, onClose, updateSelectedTemplateInStore,onSave, configurationList, onLoad, templateData, loadCallbackProfiles, callbackProfileList, profile, selectedTemplateId, onLoadUrls, onLoadTemplates, onSelectTemplate, onSelectUrl, createdUrl, urlList, selectedUrlId, fetchCountryList, countryList }) => {

    const { t } = useTranslation();

    const [vmnNumber, setVmnNumber] = useState("");
    const [keyword, setKeyword] = useState<string>("");
    const [isDefaultConfiguration, setDefaultConfiguration] = useState(false);
    const [smsRoutes, setSmsRoutes] = useState<IOptions[]>([]);
    const [expiry, setExpiry] = useState<number | null>(null);

    // Auto-reply
    const [isAutoReplyActive, setAutoReplyActive] = useState<boolean>(false);
    const [replyType, setReplyType] = useState<ReplyTypeEnum>(0);
    const [autoReplyBody, setAutoReplyBody] = useState<string>("");
    const [autoReplySenderId, setAutoReplySenderId] = useState<string | undefined>(undefined);
    const [autoReplyExpiryContent, setAutoReplyExpiryContent] = useState<string>("");
    const [autoReplyExpiryTemplateId, setAutoReplyExpiryTemplateId] = useState<string>("");
    const [senderIdOptions, setSenderIdOptions] = useState<any>([]);
    const [scheduledReplyTime, setScheduledReplyTime] = useState<Moment | null>(null);
    const [autoReplySelectedTemplateId, setAutoReplySelectedTemplateId] = useState("");
    const [checkautoReplySelectedTemplateId,setcheckAutoReplySelectedTemplateId] = useState("");
    const [autoReplySmsRoute, setAutoReplySMSRoute] = useState<string | undefined>(undefined);
    const [selectedTemplateSidebarType, setSelectedTemplateSidebarType] = useState("");

    // forward url
    const [isForwardActive, setForwardActive] = useState<boolean>(false);
    const [forwardSenderIdInfo, setForwardSenderIdInfo] = useState<any>(null);
    const [forwardToInfo, setForwardToInfo] = useState<string>("");
    const [emailForwardInfo, setEmailForwardInfo] = useState<string>("");
    const [forwardSmsRoute, setForwardSMSRoute] = useState<string | undefined>(undefined);
    const [forwardIsoValue, setFowardToIso] = useState("91");
    const [forwardToTemplateId, setForwardToTemplateId] = useState("");

    // trigger url
    const [isTriggerUrlActive, setTriggerUrlActive] = useState<boolean>(false);
    const [optInActive, setOptInActive] = useState<boolean>(false);
    const [optOutActive, setOptOutActive] = useState<boolean>(false);
    const [triggerUrl, setTriggerUrl] = useState<string>('');
    const [requestBody, setRequestBody] = useState<string>('');
    const [requestHeaders, setRequestHeaders] = useState<string>('');
    const [triggerType, setTriggerType] = useState<TriggerTypeEnum>(0);
    const [eusenderidoptions,seteusenderidoptions] = useState<any>({});
    const [callbackProfile, setCallbackProfile] = useState<string | undefined>(undefined);
    const [callbackProfileOptions, setCallbackProfileOptions] = useState<any | undefined>(undefined);

    const [isOverlaySidebarActive, setOverlaySidebarActive] = useState(false);
    const [overlaySidebarType, setOverlaySidebarType] = useState<SidebarType | null>(null);
    const [countries, setCountries] = useState<any>([]);
    const [metaData,setmetaData] = useState<any>({});
    const [isItAllSenderId,setisItAllSenderId] = useState<boolean>(false);
    const [forwardChannel, setforwardChannel] = useState<string>('SMS');

    useEffect(() => {
        loadCallbackProfiles();
        onLoadUrls();
        onLoadTemplates();
        fetchCountryList();

        if(profile?.fullProfile?.user_pod?.toLowerCase()==="eu"||profile?.fullProfile?.country_id.toString()!=="277"){
            networkCall(`get`, `/messages/identifier`,apiBaseUrl.baseUrl).then((res:any)=>{
                if(res?.data){
                    let senderarr:any = {};
                    res?.data.map((ele:any)=>{
                        senderarr[ele.identifier] = ele.identifier;
                        return ele;
                    })
                    seteusenderidoptions(senderarr);
                }
               }).catch((err: any)=>{
                console.log(err.response?.data?.message);
                });
        }

        const filteredData = getFilteredFormData(configurationList, id.id);
        setmetaData(filteredData.number_type);  
        setKeyword(filteredData.keyword);
        setVmnNumber(filteredData.vmn_number);
        setExpiry(filteredData?.expired_at || null);
        setisItAllSenderId(filteredData.meta_data?.opt_sender_all_config ?? false);
        setDefaultConfiguration(Boolean(filteredData.is_default));
        if (filteredData.forward_settings) {
            setForwardActive(true);
            setForwardSenderIdInfo(filteredData.forward_settings.sender_id);
            setEmailForwardInfo(filteredData.forward_settings.email);
            setForwardSMSRoute(filteredData.forward_settings.route || undefined);
            setForwardToTemplateId(filteredData.forward_settings.template_id);
            let forwardToArr = filteredData.forward_settings.to?.split(" ");
            if(!isEmpty(filteredData.forward_settings.email) && !isEmpty(filteredData.forward_settings.to)){
                setforwardChannel("SMS_EMAIL");
            }else if(isEmpty(filteredData.forward_settings.to)){
                setforwardChannel("EMAIL");
            }
            if (forwardToArr.length === 2) {
                setFowardToIso(forwardToArr[0]);
                setForwardToInfo(forwardToArr[1]);
            }
        }
        if (filteredData.trigger_url_settings) {
            setTriggerUrlActive(true);
            if (!isEmpty(filteredData.trigger_url_settings.url)) {
                setTriggerType(0);
            } else {
                setTriggerType(1);
            }
            setTriggerUrl(filteredData.trigger_url_settings.url);
            setRequestBody(filteredData.trigger_url_settings.request_body);
            setRequestHeaders(filteredData.trigger_url_settings.request_headers);

        }
        if (filteredData.auto_reply_settings) {
            setAutoReplyActive(true);
            setAutoReplySMSRoute(filteredData.auto_reply_settings.route);
            setAutoReplySenderId(filteredData?.auto_reply_settings?.sender_id);
            setAutoReplyBody(filteredData?.auto_reply_settings?.message);
            setAutoReplyExpiryContent(filteredData?.auto_reply_settings?.expiry_content || "");
            setAutoReplySelectedTemplateId(filteredData?.auto_reply_settings?.template_id);
            setcheckAutoReplySelectedTemplateId(filteredData?.auto_reply_settings?.template_id);
            setAutoReplyExpiryTemplateId(filteredData?.auto_reply_settings?.expiry_template_id || "");
            if (Boolean(filteredData.auto_reply_settings?.is_scheduled)) {
                setReplyType(1);
                setScheduledReplyTime(moment.unix((filteredData?.auto_reply_settings?.scheduled_time || 0)) || null);
            }
        }
        if (filteredData.opt_settings === "OPT-IN") {
            setOptInActive(true);
        } else if (filteredData.opt_settings === "OPT-OUT") {
            setOptOutActive(true);
        }
    }, []);

    useEffect(() => {
        const filteredData = getFilteredFormData(configurationList, id.id);
        let res = getCallbackProfileOptions();
        setCallbackProfileOptions(res);
        if (callbackProfileList.length) {
            setCallbackProfile(filteredData?.trigger_url_settings?.callback_profile_id || undefined);
        }
    }, [callbackProfileList])

    useEffect(() => {
        if (templateData) {
            if(profile?.fullProfile?.user_pod?.toLowerCase()==="eu"||profile?.fullProfile?.country_id.toString()!=="277"){
                loadSenderIdOptions(eusenderidoptions)
            }else{
            loadSenderIdOptions(templateData.smsTemplatesData?.sender_array);
            }
            storeSmsRoutes(templateData.smsTemplatesData?.routes);
        }
    }, [templateData, urlList]);

    useEffect(() => {
        if (selectedTemplateId !== "") {
            const _selectedTemplate = (templateData?.smsTemplatesData?.data).find((templateData: any) => templateData.id === selectedTemplateId);

            if ((autoReplyBody + " " + _selectedTemplate.content).length > 4000) {
                return;
            }

            if ((autoReplyExpiryContent + " " + _selectedTemplate.content).length > 4000) {
                return;
            }

            if (selectedTemplateSidebarType === TemplateTypeSidebar.AUTO_REPLY_BODY) {
                setAutoReplyBody(autoReplyBody + " " + _selectedTemplate.content);
                setAutoReplySelectedTemplateId(_selectedTemplate.template_id);
                setcheckAutoReplySelectedTemplateId(_selectedTemplate.template_id);
            } else if (selectedTemplateSidebarType === TemplateTypeSidebar.AUTO_REPLY_EXPIRY_BODY) {
                setAutoReplyExpiryContent(autoReplyExpiryContent + " " + _selectedTemplate.content)
            }
            updateSelectedTemplateInStore("");
        }
    }, [selectedTemplateId, selectedTemplateSidebarType]);

    useEffect(() => {
        if (selectedUrlId !== "") {
            const _selectedUrl = urlList.find((urlData: any) => urlData.id === selectedUrlId);

            if ((autoReplyBody + " " + _selectedUrl.short_url).length > 4000) {
                return;
            }

            if ((autoReplyExpiryContent + " " + _selectedUrl.short_url).length > 4000) {
                return;
            }

            if (selectedTemplateSidebarType === TemplateTypeSidebar.AUTO_REPLY_BODY) {
                setAutoReplyBody(autoReplyBody + " " + _selectedUrl.short_url);
            } else if (selectedTemplateSidebarType === TemplateTypeSidebar.AUTO_REPLY_EXPIRY_BODY) {
                setAutoReplyExpiryContent(autoReplyExpiryContent + " " + _selectedUrl.short_url);
            }
        }
    }, [selectedUrlId]);


    useEffect(() => {
        if (createdUrl !== "") {

            if ((autoReplyBody + " " + createdUrl).length > 4000) {
                return;
            }

            if ((autoReplyExpiryContent + " " + createdUrl).length > 4000) {
                return;
            }

            if (selectedTemplateSidebarType === TemplateTypeSidebar.AUTO_REPLY_BODY) {
                setAutoReplyBody(autoReplyBody + " " + createdUrl);
            } else if ((selectedTemplateSidebarType === TemplateTypeSidebar.AUTO_REPLY_EXPIRY_BODY)) {
                setAutoReplyExpiryContent(autoReplyExpiryContent + " " + createdUrl);
            }
        }
    }, [createdUrl])

    useEffect(() => {
        if (Array.isArray(countryList)) {
            let country = countryList.map((item: any) => ({
                "countryid": item.country_id,
                "name": item.name,
                "code": item.code,
                "isoCode": item.iso_code
            }))
            setCountries([...country])
        }
    }, [countryList])

    const loadSenderIdOptions = (senderArray: Record<string, string>[]) => {
        let senderIds = [];
        for (var key in senderArray) {
            senderIds.push({ key: key?.replace(/ /g, "\u00A0"), value: senderArray[key].toString()?.replace(/ /g, "\u00A0") })
        }
        setSenderIdOptions([...senderIds]);
    }

    const handleTemplateIdValidationLabelType = (templateId: string) => {
        return ((templateId?.length === 0) || (validateOnlyNumbers(templateId) && (templateId?.length >= 12 && templateId?.length <= 30)) ? "success" : "error");
    }

    const handleTemplateIdValidationLabel = (templateId: string) => {
        return ((templateId?.length === 0) || (validateOnlyNumbers(templateId) && ((templateId?.length === 0) || (templateId?.length >= 12 && templateId?.length <= 30))) ? "" : "Invalid Template Id");
    }

    const isTemplateIdValid = (templateId: string) => {
        return handleTemplateIdValidationLabelType(templateId) === "success" && handleTemplateIdValidationLabel(templateId) === "";
    }

    const getFilteredFormData = (configurationList: ConfigurationData[], id: string): ConfigurationData => (
        configurationList.find((listItem: ConfigurationData) => listItem.id === id) as ConfigurationData
    )

    const isActiveFormValid = () => {
        let smsDetails = (!isEmpty(forwardToInfo) && !isEmpty(forwardSenderIdInfo) && (forwardIsoValue !== "91" || (forwardIsoValue === "91" && !isEmpty(forwardToTemplateId) && isTemplateIdValid(forwardToTemplateId))) && !isEmpty(forwardSmsRoute));
        let emailDetails = (!isEmpty(emailForwardInfo) && validateEmail(emailForwardInfo));
        const flag1 = !isForwardActive || (isForwardActive && (forwardChannel === "SMS_EMAIL" ? (smsDetails && emailDetails):((forwardChannel === "SMS" && smsDetails) || (forwardChannel === "EMAIL" && emailDetails))));
        const flag2 = !isTriggerUrlActive || (isTriggerUrlActive && triggerType === 0 && !isEmpty(triggerUrl) || (isTriggerUrlActive && triggerType === 1 && !isEmpty(callbackProfile)))
        const flag3 = !isAutoReplyActive || (isAutoReplyActive && isContentValid(autoReplyBody) && ((expiry !== null && expiry > 0) ? (isContentValid(autoReplyExpiryContent) && isTemplateIdValid(autoReplyExpiryTemplateId)) : true) && !isEmpty(autoReplySenderId) && !isEmpty(autoReplyBody) && isTemplateIdValid(autoReplySelectedTemplateId));
        return flag1 && flag2 && flag3;
    }

    const getFooter = (): React.ReactNode => {
        return (
            <div className={Styles.flexEnd}>
                <Button type="tertiary" onClick={onClose}>
                    {t('mainCancel')}
                </Button>
                <Button type="primary" disabled={!isActiveFormValid()} onClick={() => handleFormSave()}>
                    {t('mainSave')}
                </Button>
            </div>
        );
    };

    const updateCallback = (res: any, flag: boolean) => {
        if (flag) {
            Toast(res?.message, "success");
            onLoad();
            onClose();
        } else {
            Toast(res?.data?.message, "error");
        }
    }

    const storeSmsRoutes = (routes: any[]) => {
        let _smsRoutes: IOptions[] = [];
        for (const key in routes) {
            if (key.toString() !== "OTP" && key.toString() !== "M2M") {
                _smsRoutes.push({
                    label: key,
                    value: key
                })
            }
        }
        setSmsRoutes([..._smsRoutes]);
    }

    const convertToFormPayload = () => {
        let formPayload: any = {
            keyword_id: id.id,
            keyword: !isEmpty(keyword) ? keyword : undefined,
            is_default: Number(isDefaultConfiguration),
            vmn_number: vmnNumber,
            expired_at: expiry,
            meta_data: {number_type: Number(metaData), opt_sender_all_config: isItAllSenderId? 1: 0}
        }
        if (isAutoReplyActive) {
            formPayload["auto_reply_settings"] = {
                "sender_id": autoReplySenderId,
                "route": autoReplySmsRoute,
                "message": autoReplyBody,
                "template_id": autoReplySelectedTemplateId,
                "expiry_content": expiry ? autoReplyExpiryContent : "",
                "expiry_template_id": expiry ? autoReplyExpiryTemplateId : "",
                "is_scheduled": Boolean(replyType),
                "scheduled_time": replyType === 1 && scheduledReplyTime?.unix()
            }
        }
        if (isForwardActive) {
            switch(forwardChannel) {
                case "SMS":
                    formPayload["forward_settings"] = {
                        "to": forwardToInfo ? `${forwardIsoValue} ${forwardToInfo}` : "",
                        "sender_id": forwardSenderIdInfo,
                        "route": forwardSmsRoute || undefined,
                        "template_id": forwardIsoValue === "91" ? forwardToTemplateId : ""
                    }
                    break;

                case "EMAIL":
                    formPayload["forward_settings"] = {
                        "email": emailForwardInfo || undefined,
                    }
                    break;
            
                default:
                    formPayload["forward_settings"] = {
                        "to": forwardToInfo ? `${forwardIsoValue} ${forwardToInfo}` : "",
                        "email": emailForwardInfo || undefined,
                        "sender_id": forwardSenderIdInfo,
                        "route": forwardSmsRoute || undefined,
                        "template_id": forwardIsoValue === "91" ? forwardToTemplateId : ""
                    }
                    break;
            }
        }
        if (isTriggerUrlActive) {
            formPayload["trigger_url_settings"] = {
                "url": triggerType === 0 && triggerUrl,
                "request_body": triggerType === 0 && requestBody,
                "request_headers": triggerType === 0 && requestHeaders,
                "callback_profile_id": triggerType === 1 && callbackProfile,
            }
        }
        if (optInActive || optOutActive) {
            formPayload["opt_settings"] = optInActive ? "OPT-IN" : "OPT-OUT";
        }
        return formPayload;
    }

    const handleFormSave = () => {
        const formPayload = convertToFormPayload();
        onSave(formPayload, updateCallback)
    }

    const getCallbackProfileOptions = () => {
        let callbackProfileOptions: IOptions[] = [];
        callbackProfileList.map((callbackProfileItem: any) => {
            callbackProfileOptions.push({ label: callbackProfileItem.title, value: callbackProfileItem.profile_id });
        });
        return callbackProfileOptions;
    }

    const getFormBody = () => {
        return (
            <div className={Styles.formWrapper}>
                <Row>
                    <Col size={12}>
                        <div className={cn(!isEmpty(keyword) ? Styles.titleText : Styles.noTitleText)}>
                            <span >{keyword}</span>
                        </div>
                    </Col>
                </Row>
                <Row className={Styles.inputField}>
                    <Col size={6} className={metaData === 4?Styles.hideDefaultConfigCheck:""}>
                        <Checkbox label={t('KLR03019')} disabled={metaData === 4} checked={metaData !== 4 && isDefaultConfiguration} onChange={(e) => setDefaultConfiguration(e.target.checked)} />
                    </Col>
                </Row>
                <Row>
                    <Col size={10}>
                        <div className={Styles.sectionInfo}>
                            <h2 className={Styles.heading}>{t('KLR03021')}</h2>
                            <p className={Styles.stepDescription}>{t('KLR03020')}</p>
                        </div>
                    </Col>
                    <Col size={2}>
                        <Toggle checked={isAutoReplyActive} onChange={(flag: boolean) => setAutoReplyActive(flag)} />
                    </Col>
                </Row>
                {
                    isAutoReplyActive && <div className={Styles.formWrapper}>
                        <Row>
                            <Col size={12}>
                                <Select placeholder={t('BLD00613')} value={autoReplySenderId} label={t('BLD00613')} options={senderIdOptions} onChange={(value: any) => setAutoReplySenderId(value)}></Select>
                            </Col>
                        </Row>
                        <Row>
                            <Col size={12}>
                                <TextArea placeholder={t('KLR00104')} label={t('KLR00104')} value={autoReplyBody} onChange={(e: any) => {if(removeEmojisTextfield(e.target.value)){setAutoReplyBody(e.target.value)}}}
                                    showDetailsFooter={true}
                                    characterLimit={4000}
                                    showInsertLinkOption={true}
                                    showBottomLabelSpace={false}
                                    showMessageCount={true}
                                    showAttachmentOption
                                    bottomLabelType={(autoReplyBody.length === 0 || isContentValid(autoReplyBody)) ? "default" : "error"}
                                    showEncodingInfo
                                    encodingText={`${checkTextEncodingType(autoReplyBody)} Encoding`}
                                    customAttachIcon={TemplateAttachIcon}
                                    onCustomAttach={() => { setOverlaySidebarActive(true); setOverlaySidebarType(0); setSelectedTemplateSidebarType(TemplateTypeSidebar.AUTO_REPLY_BODY) }}
                                    rows={5}
                                    onInsertLink={() => { setOverlaySidebarActive(true); setOverlaySidebarType(1); setSelectedTemplateSidebarType(TemplateTypeSidebar.AUTO_REPLY_BODY) }}
                                />
                            </Col>
                        </Row>
                        {!isEmpty(checkautoReplySelectedTemplateId) && <Row className={Styles.scheduledReplyFormRow}>
                            <Input label={t('verifyTemplateId')} placeholder={t('verifyTemplateId')} value={autoReplySelectedTemplateId} bottomLabelType={handleTemplateIdValidationLabelType(autoReplySelectedTemplateId)}
                                bottomLabel={handleTemplateIdValidationLabel(autoReplySelectedTemplateId)} onChange={(e:any)=>setAutoReplySelectedTemplateId(e.target.value)}/>
                        </Row>}
                        <Row>
                            <Col size={12}>
                                <Select label={t('KLR03022')} placeholder={t('KLR03022')} value={autoReplySmsRoute} options={smsRoutes} onChange={(value: any) => setAutoReplySMSRoute(value)} />
                            </Col>
                        </Row>
                        {expiry && <Row>
                            <Col size={12}>
                                <TextArea placeholder={t('KLR03050')} label={t('KLR03050')} value={autoReplyExpiryContent} onChange={(e: any) => {if(removeEmojisTextfield(e.target.value)){setAutoReplyExpiryContent(e.target.value)}}}
                                    showDetailsFooter={true}
                                    characterLimit={4000}
                                    showInsertLinkOption={true}
                                    showBottomLabelSpace={false}
                                    showMessageCount={true}
                                    showAttachmentOption
                                    bottomLabelType={(autoReplyExpiryContent.length === 0 || isContentValid(autoReplyExpiryContent)) ? "default" : "error"}
                                    showEncodingInfo
                                    encodingText={`${checkTextEncodingType(autoReplyExpiryContent)} Encoding`}
                                    customAttachIcon={TemplateAttachIcon}
                                    onCustomAttach={() => { setOverlaySidebarActive(true); setOverlaySidebarType(0); setSelectedTemplateSidebarType(TemplateTypeSidebar.AUTO_REPLY_EXPIRY_BODY) }}
                                    rows={5}
                                    onInsertLink={() => { setOverlaySidebarActive(true); setOverlaySidebarType(1); setSelectedTemplateSidebarType(TemplateTypeSidebar.AUTO_REPLY_EXPIRY_BODY) }}
                                />
                                <Input
                                    label={t('KLR03135')}
                                    placeholder={t('KLR03135')}
                                    value={autoReplyExpiryTemplateId}
                                    onChange={(e: any) => setAutoReplyExpiryTemplateId(e.target.value)}
                                    showBottomLabelSpace={true}
                                    bordered
                                    bottomLabelType={handleTemplateIdValidationLabelType(autoReplyExpiryTemplateId)}
                                    bottomLabel={handleTemplateIdValidationLabel(autoReplyExpiryTemplateId)}
                                />
                            </Col>
                        </Row>}
                        <Row>
                            <Col size={12}>
                                <span className={Styles.replyTypeText}>{t('KLR03024')}</span>
                            </Col>
                        </Row>
                        <Row className={Styles.scheduledReplyFormRow}>
                            <Col size={6}>
                                <Radio name="instant" value={replyType} checked={replyType === 0} onClick={() => setReplyType(0)}>{t('KLR03025')}</Radio>
                            </Col>
                            <Col size={6}>
                                <Radio name="scheduled" className={Styles.replyRadioBtn} value={replyType} checked={replyType === 1} onClick={() => setReplyType(1)}>{t('KLR03026')}</Radio>
                            </Col>
                        </Row>

                        {replyType === 1 &&
                            <>
                                <Row className={Styles.scheduledReplyFormRow}>
                                    <Col size={12}>
                                        <DatePicker showTime showSecond={false} placeholder={t('klr0003')} value={scheduledReplyTime} onChange={(date: any) => setScheduledReplyTime(date)} className={Styles.scheduledItem} disabledDate={(current: any) => {
                                            return current && (current < moment().minutes(moment().minutes()+15) || current > moment().add(3, 'month'));
                                        }} allowClear />
                                    </Col>
                                </Row>
                            </>}
                    </div>
                }
                <Row>
                    <Col size={10}>
                        <div className={Styles.sectionInfo}>
                            <h2 className={Styles.heading}>{t('KLR03027')}</h2>
                            <p className={Styles.stepDescription}>{t('KLR03028')}</p>
                        </div>
                    </Col>
                    <Col size={2}>
                        <Toggle checked={isForwardActive} onChange={(flag: boolean) => setForwardActive(flag)} />
                    </Col>
                </Row>
                {
                    isForwardActive &&
                    <div className={Styles.formWrapper}>
                        <h2 className={Styles.stepDescription}>{t('receiveMessageForward')}</h2>
                        <Row className={Styles.configurationToggleFormRow}>
                            <Col size={4}>
                                <Radio name="SMS" value={"SMS"} checked={forwardChannel === "SMS"} onClick={() => setforwardChannel("SMS")}>{t('mainSMS')}</Radio>
                            </Col>
                            <Col size={4}>
                                <Radio name="EMAIL" value={"EMAIL"} checked={forwardChannel === "EMAIL"} onClick={() => setforwardChannel("EMAIL")}>{t('mainEmail')}</Radio>
                            </Col>
                            <Col size={4}>
                                <Radio name="SMS_EMAIL" value={"SMS_EMAIL"} checked={forwardChannel === "SMS_EMAIL"} onClick={() => setforwardChannel("SMS_EMAIL")}>{t('receiveMessageSMSAndEmail')}</Radio>
                            </Col>
                        </Row>
                        {new Array("SMS","SMS_EMAIL").includes(forwardChannel) && 
                        <>
                            <h2 className={Styles.stepDescription}>{t('receiveMessageSMSDetails')}</h2>
                            <Row className={Styles.configurationToggleFormRow}>
                                <CountryDropdown
                                    data={countries}
                                    defaultSelectValue={forwardIsoValue}
                                    value={forwardToInfo}
                                    label={t('KLR03002')}
                                    mode="iso"
                                    onDropdownChange={(code: string) => setFowardToIso(code)}
                                    onChange={(e: any) => { setForwardToInfo(e.target.value) }}
                                    placeholder={t('KLR03002')}
                                    showBottomLabelSpace={false}
                                />
                            </Row>
                            <Row className={Styles.configurationToggleFormRow}>
                                <Select placeholder={t('BLD00613')} options={senderIdOptions} showBottomLabelSpace={false} label={t('BLD00613')} value={forwardSenderIdInfo} onChange={(option: any) => setForwardSenderIdInfo(option)}></Select>
                            </Row>
                            <Row className={Styles.configurationToggleFormRow}>
                                <Select label={t('KLR03022')} showBottomLabelSpace={false} placeholder={t('KLR03022')} value={forwardSmsRoute} options={smsRoutes} onChange={(value: any) => setForwardSMSRoute(value)} />
                            </Row>
                            {forwardIsoValue === "91" &&
                                <Row className={Styles.configurationToggleFormRow}>
                                    <Input label={t('verifyTemplateId')} placeholder={t('verifyTemplateId')} value={forwardToTemplateId} onChange={(e: any) => setForwardToTemplateId(e.target.value)} bottomLabelType={handleTemplateIdValidationLabelType(forwardToTemplateId)}
                                        bottomLabel={handleTemplateIdValidationLabel(forwardToTemplateId)} />
                                </Row>}
                            </>}
                        {new Array("EMAIL","SMS_EMAIL").includes(forwardChannel) && <Row className={Styles.configurationToggleFormRow}>
                            <h2 className={Styles.stepDescription}>{t('receiveMessageEmailDetails')}</h2>
                            <Input placeholder={t('KLR03029')}
                                label={t('KLR03029')}
                                value={emailForwardInfo}
                                onChange={(e: any) => setEmailForwardInfo(e.target.value)}
                                bottomLabelType={(isEmpty(emailForwardInfo) || validateEmail(emailForwardInfo || "")) ? "default" : "error"}
                                showBottomLabelSpace={false}
                            />
                        </Row>}
                    </div>}
                <Row className={Styles.configurationFormRow}>
                    <Col size={10}>
                        <div className={Styles.sectionInfo}>
                            <h2 className={Styles.heading}>{t('KLR03016')}</h2>
                            <p className={Styles.stepDescription}>{t('KLR03030')}</p>
                        </div>
                    </Col>
                    <Col size={2}>
                        <Toggle checked={isTriggerUrlActive} onChange={(flag: boolean) => setTriggerUrlActive(flag)} />
                    </Col>
                </Row>
                {
                    isTriggerUrlActive &&
                    <div className={Styles.formWrapper}>
                        <Row className={Styles.scheduledReplyFormRow}>
                            <Col size={6}>
                                <Radio name="trigger_url" value={triggerType} checked={triggerType === 0} onClick={() => setTriggerType(0)}>{t('KLR03016')}</Radio>
                            </Col>
                            <Col size={6}>
                                <Radio name="callback_id" className={Styles.replyRadioBtn} value={triggerType} checked={triggerType === 1} onClick={() => setTriggerType(1)}>{t('KLR03031')}</Radio>
                            </Col>
                        </Row>
                        {triggerType === 0 ?
                            <>
                                <Row className={Styles.configurationToggleFormRow}>
                                    <Input placeholder={t('KLR03016')}
                                        label={t('KLR03016')}
                                        value={triggerUrl}
                                        onChange={(e: any) => setTriggerUrl(e.target.value)}
                                        showBottomLabelSpace
                                        bottomLabel="Ex: http://website.com/api.php?source={source}&message={message}&keyword={keyword}"
                                        bottomLabelType="default"
                                        className={Styles.inputWithBottomLabel}
                                    />
                                </Row>
                                <Row className={Styles.configurationToggleFormRow}>
                                    <Input placeholder={t('reqBody')}
                                        label={t('reqBody')}
                                        value={requestBody}
                                        onChange={(e: any) => setRequestBody(e.target.value)}
                                        className={Styles.inputWithBottomLabel}
                                        showBottomLabelSpace
                                        bottomLabel="Ex: source={source}&message={message}&keyword={keyword}"
                                        bottomLabelType="default"
                                    />
                                </Row>
                                <Row className={Styles.configurationToggleFormRow}>
                                    <Input placeholder={t('KLR03032')}
                                        label={t('KLR03032')}
                                        value={requestHeaders}
                                        onChange={(e: any) => setRequestHeaders(e.target.value)}
                                        className={Styles.inputWithBottomLabel}
                                        showBottomLabelSpace
                                        bottomLabel="Ex: Content-Type=application/json"
                                        bottomLabelType="default"
                                    />
                                </Row></> :
                            <Row className={Styles.configurationToggleFormRow}>
                                <Select placeholder={t('KLR03033')} showBottomLabelSpace={false} label={t('KLR03033')} options={callbackProfileOptions} value={callbackProfile} onChange={(option: any) => setCallbackProfile(option)}></Select>
                            </Row>
                        }
                    </div>
                }
                <Row className={cn(Styles.configurationFormRow, "mb-3")}>
                    <Col size={10}>
                        <div className={Styles.sectionInfo}>
                            <h2 className={Styles.heading}>{t('optInLabel')}</h2>
                            <p className={Styles.stepDescription}>{t('subscribeSmsDesc')}</p>
                        </div>
                    </Col>
                    <Col size={2}>
                        <Toggle checked={optInActive} onChange={(flag: boolean) => {
                            setOptInActive(flag);
                            if (flag) {
                                setOptOutActive(false);
                            }
                        }} />
                    </Col>
                </Row>
                <Row className={Styles.configurationFormRow}>
                    <Col size={10}>
                        <div className={Styles.sectionInfo}>
                            <h2 className={Styles.heading}>{t('optOutLabel')}</h2>
                            <p className={Styles.stepDescription}>{t('unsubscribeSmsDesc')}</p>
                        </div>
                    </Col>
                    <Col size={2}>
                        <Toggle checked={optOutActive} onChange={(flag: boolean) => {
                            setOptOutActive(flag);
                            if (flag) {
                                setOptInActive(false);
                            }
                        }} />
                    </Col>
                </Row>
                {optOutActive && <><Row style={{marginTop:"10px"}} className={Styles.configurationFormRow}>  
                <div className={Styles.sectionInfo}>
                    <p className={Styles.stepDescription}>{t('EnableUniversalOptOutLabel')}</p>
                </div>
                </Row>
               <Row>
                <Radio style={{ flex:"1 0"}} name="EnableUniversalOptOutRadio" value={isItAllSenderId} checked={!isItAllSenderId} onClick={() => setisItAllSenderId(false)}>{t('ConfiguredSenderIdRadioButton')}</Radio>
                <Radio style={{ flex:"1 0"}} name="EnableUniversalOptOutRadio" value={isItAllSenderId} checked={isItAllSenderId} onClick={() => setisItAllSenderId(true)}>{t('AllSenderIdRadioButton')}</Radio>
                </Row>
                </>}
            </div>
        )
    }

    const isContentValid = (contentBody: string) => {
        return contentBody.trim().length > 0
    }

    return (<>
        <Slider
            containerId="root-modal"
            onClose={onClose}
            visibility={true}
            footer={getFooter()}
            title={t('KLR03003')}
        >
            <div className={Styles.container}>{getFormBody()}</div>
        </Slider>
        {
            isOverlaySidebarActive &&
            <Slider containerId='root-modal'
                onClose={() => setOverlaySidebarActive(false)}
                visibility={true}
                title={overlaySidebarType === 0 ? t('mainSelectTemplate') : t('KLR03039')}
            >
                {overlaySidebarType !== null &&
                    (overlaySidebarType === 0 ? <>
                        <SelectTemplate showAsOverlaySlider={true} data={templateData?.smsTemplatesData?.data || []} closeOverlaySidebar={() => setOverlaySidebarActive(false)} _sidebarType={selectedTemplateSidebarType} _getSidebarTyoe={(type: string) => setSelectedTemplateSidebarType(type)} /></> :
                        <SelectUrl data={urlList} showAsOverlaySlider={true} closeOverlaySidebar={() => setOverlaySidebarActive(false)} _sidebarType={selectedTemplateSidebarType} _getSidebarTyoe={(type: string) => setSelectedTemplateSidebarType(type)} />)}

            </Slider>
        }
    </>
    );
}

export default ConfigurationEditForm;